function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classnames from 'classnames';
import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { AccordionAnimations } from "../../../../../enums/accordion.js";
import "../../../../../enums/alert.js";
import "../../../../../enums/avatar.js";
import "../../../../../enums/breakpoints.js";
import "../../../../../enums/button.js";
import "../../../../../enums/code-editor.js";
import "../../../../../enums/colors.js";
import "../../../../../enums/combobox.js";
import "../../../../../enums/date.js";
import "../../../../../enums/drag-and-drop.js";
import "../../../../../enums/dialog.js";
import "../../../../../enums/divider.js";
import "../../../../../enums/dropdown.js";
import "../../../../../enums/fieldset.js";
import "../../../../../enums/font-icon.js";
import "../../../../../enums/fonts.js";
import "../../../../../enums/headings.js";
import "../../../../../enums/input.js";
import "../../../../../enums/keys.js";
import "../../../../../enums/list.js";
import "../../../../../enums/listbox.js";
import "../../../../../enums/loader.js";
import "../../../../../enums/margin.js";
import "../../../../../enums/option.js";
import "../../../../../enums/pill.js";
import "../../../../../enums/placements.js";
import "../../../../../enums/popout.js";
import "../../../../../enums/privacy.js";
import "../../../../../enums/radio-group.js";
import "../../../../../enums/status.js";
import "../../../../../enums/switch.js";
import "../../../../../enums/table.js";
import "../../../../../enums/tooltip.js";
import "../../../../../enums/transitions.js";
import "../../../../../enums/widths.js";
import classes from "../styles/accordion-panel.module.scss.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Accordion panel content.
 * @param {AccordionPanelProps} props AccordionPanelProps
 */
var AccordionPanel = function AccordionPanel(props) {
  var accordionButtonId = props.accordionButtonId,
    _props$animation = props.animation,
    animation = _props$animation === void 0 ? AccordionAnimations.FadeInFromTop : _props$animation,
    children = props.children,
    id = props.id,
    loading = props.loading,
    open = props.open,
    panelProps = props.panelProps,
    unmountOnExit = props.unmountOnExit;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hidden = _useState2[0],
    setHidden = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    initial = _useState4[0],
    setInitial = _useState4[1];
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: {
      enter: classes["".concat(animation, "Enter")],
      enterActive: classes["".concat(animation, "EnterActive")],
      enterDone: classes["".concat(animation, "EnterDone")],
      exit: classes["".concat(animation, "Exit")],
      exitActive: classes["".concat(animation, "ExitActive")]
    },
    in: open,
    onEnter: function onEnter() {
      return setHidden(false);
    },
    onEntered: function onEntered() {
      return setInitial(false);
    },
    onExited: function onExited() {
      return setHidden(true);
    },
    timeout: !initial && !loading ? 200 : 0,
    unmountOnExit: unmountOnExit
  }, /*#__PURE__*/React.createElement("section", _extends({}, panelProps, {
    "aria-labelledby": accordionButtonId,
    className: classnames('accordion-panel', classes.accordionPanel, panelProps === null || panelProps === void 0 ? void 0 : panelProps.className),
    hidden: hidden,
    id: id
  }), children));
};
export { AccordionPanel };